<lib-question-display [question]="_question.value" />
@if (_question.isMultipleChoice) {
  <div class="options" [attr.data-count]="_question.choices.length">
    @for (option of _question.choices; track option; let index = $index) {
      <ion-checkbox
        [value]="option.value"
        [checked]="isSelected(option.value)"
        (ionChange)="onMultiSelect(option.value)"
        [attr.custom-index]="Alfabet[index]"
        [disabled]="_disabled"
        name="value"
        labelPlacement="end"
        justify="start"
      >
        <div style="display: flex; gap: 10px">
          <span class="children-no-margin">{{ Alfabet[index] }}. </span>
          <span
            class="children-no-margin white-space"
            [innerHTML]="option.value | displayMath"
          ></span>
        </div>
      </ion-checkbox>
    }
  </div>
  <p class="info-multiple-answers">Meerdere antwoorden mogelijk</p>
} @else {
  <ion-radio-group
    class="options-radio"
    [value]="singleChoiceAnswer$ | async"
    [attr.data-count]="_question.choices.length"
    (ionChange)="onSingleSelect($event.detail.value)"
  >
    <div class="radio-group-wrapper">
      @for (option of _question.choices; track option; let index = $index) {
        <ion-radio
          [value]="option.value"
          [attr.custom-index]="Alfabet[index]"
          [disabled]="_disabled"
          name="value"
          labelPlacement="end"
          justify="start"
        >
          <div style="display: flex; gap: 10px">
            <span class="children-no-margin">{{ Alfabet[index] }}. </span>
            <span
              class="children-no-margin white-space"
              [innerHTML]="option.value | displayMath"
            ></span>
          </div>
        </ion-radio>
      }
    </div>
  </ion-radio-group>
}
